import { render, staticRenderFns } from "./ModalCenter.vue?vue&type=template&id=f6f318ba"
import script from "./ModalCenter.vue?vue&type=script&lang=js"
export * from "./ModalCenter.vue?vue&type=script&lang=js"
import style0 from "./ModalCenter.vue?vue&type=style&index=0&id=f6f318ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports